import axios, { AxiosResponse } from 'axios'
import { Marketplace } from '@/shared/enums/marketplace'

export default class ThorConfigService {
  getThorConfigList (marketPlace: Marketplace): Promise<AxiosResponse> {
    return axios.get(`api/marketplaces/${marketPlace}/thor/configs`)
  }
}
